'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _prefix = require('../prefix');

var _prefix2 = _interopRequireDefault(_prefix);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Support scroll-snap props syntax.
// https://caniuse.com/#search=scroll-snap
exports['default'] = {
  supportedProperty: function supportedProperty(prop) {
    if (prop.substring(0, 11) !== 'scroll-snap') return false;
    if (_prefix2['default'].js === 'ms') {
      return '' + _prefix2['default'].css + prop;
    }
    return prop;
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/css-vendor/lib/plugins/scroll-snap.js
// module id = 17
// module chunks = 0